import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";

type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

interface props {
  message: any;
}

export default function ErrorSnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message.length > 1) {
      setOpen(true);
      setTransition(() => TransitionUp);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
    if (message.length === 0) {
      setOpen(false);
      setTransition(() => TransitionUp);
    }
  }, [message]);

  
  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={transition}
        sx={{ marginTop: "50px" }}
      >
        <div style={{ background: "#FF6161", borderRadius: "10px " }}>
          <div style={{ marginLeft: "30px" }}>
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: "max-content",
                height: "50px",
                fontSize: "16px",
                
                display: "flex",
                alignItems: "center",
                background: "#F9E7E7",
                padding: "0 10px !important",
              }}
            >
              {message}
            </Alert>
          </div>
        </div>
      </Snackbar>
    </div>
  );
}
